module.exports = __webpack_public_path__ + "media/images/publish-17d6d6b75acd23ed06eaed511ca11557.png";